import React from 'react';

type ProgressBarColors = {
  under: { from: string; to: string };
  full: { from: string; to: string };
  over: { from: string; to: string };
};

type Props = {
  percent: number;
  colors: ProgressBarColors;
};

export const defaultHeroMetricsColors: ProgressBarColors = {
  under: { from: '#0f172a', to: '#334f90' },
  full: { from: '#0f172a', to: '#334f90' },
  over: { from: '#dc2626', to: '#ef4444' }
};

export function ProgressBar({ percent, colors }: Props) {
  const isOver = percent > 100;

  if (isOver) {
    const overage = ((percent - 100) / percent) * 100;
    return (
      <div
        className="flex h-2 w-full overflow-hidden rounded-lg"
        style={{ boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.15)' }}>
        <div
          className="rounded-l-lg"
          style={{
            width: `${100 - overage}%`,
            background: `linear-gradient(to right, ${colors.full.from}, ${colors.full.to})`
          }}
        />
        <div
          className="rounded-r-lg"
          style={{
            width: `${overage}%`,
            background: `linear-gradient(to right, ${colors.over.from}, ${colors.over.to})`
          }}
        />
      </div>
    );
  }

  const fillPercent = Math.min(Math.max(percent, 0), 100);
  const fillColors = percent >= 100 ? colors.full : colors.under;

  return (
    <div
      className="relative h-2 w-full overflow-hidden rounded-lg bg-gray-100"
      style={{ boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.15)' }}>
      {fillPercent > 0 && (
        <div
          className="absolute inset-y-0 left-0 rounded-lg"
          style={{
            width: `${fillPercent}%`,
            background: `linear-gradient(to right, ${fillColors.from}, ${fillColors.to})`
          }}
        />
      )}
    </div>
  );
}
